import { useEffect, useState } from 'react';
import { draftSummary, listDrafts, subscribeDrafts } from './drafts';
import { getAppMode, isDisconnected, isOffline, subscribeNetwork } from './network';
import { readRefCache } from './refCache';

export function useNetworkStatus() {
  const [offline, setOffline] = useState(isOffline());
  useEffect(() => subscribeNetwork(setOffline), []);
  return offline;
}

// الوضع المختار (أونلاين/أوفلاين) وحالة الاتصال الفعلية، يتحدثان مع كل تغيير.
export function useAppMode() {
  const read = () => ({ mode: getAppMode(), disconnected: isDisconnected() });
  const [state, setState] = useState(read);
  useEffect(() => subscribeNetwork(() => setState(read())), []);
  return state;
}

// ملخص الفحوصات المحفوظة على الجهاز، يتحدث مع كل حفظ أو رفع.
export function useDeviceDrafts() {
  const [drafts, setDrafts] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      const rows = (await listDrafts()).map(draftSummary);
      // أسماء الشركة والموديل من البيانات المرجعية المحفوظة، لتظهر في القائمة كبقية الفحوصات.
      const [manufacturers, models] = await Promise.all([readRefCache('manufacturers'), readRefCache('models')]);
      const nameOf = (list, id) => (list || []).find((row) => String(row.id) === String(id))?.name || '';
      const enriched = rows.map((row) => ({
        ...row,
        manufacturer: nameOf(manufacturers, row.manufacturer_id),
        model: nameOf(models, row.model_id),
      }));
      if (mounted) setDrafts(enriched);
    };
    load();
    const unsubscribe = subscribeDrafts(load);
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  return drafts;
}
